// extracted by mini-css-extract-plugin
export default {"heading":"AboutPage_heading__TqSJo","wrapper":"AboutPage_wrapper__ulxLN"};